<template>
    <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.66602 10.1067L2.66602 6.10671L7.99935 6.10671L7.99935 2.88004L13.226 8.10671L7.99935 13.3334L7.99935 10.1067L2.66602 10.1067Z" :fill="iconColor"/>
    </svg>
  </template>
  
  <script>
  export default {
  name: "IconBoldArrowRight",
  props: {
      iconName: {
        type: String,
        default: "IconBoldArrowRight",
      },
      width: {
        type: [Number, String],
        default: 16,
      },
      height: {
        type: [Number, String],
        default: 16,
      },
      iconColor: {
        type: String,
        default: "grey",
      },
    },
  };
  </script>
  